module.exports = __webpack_public_path__ + "media/hallBgm.cb36de11.mp3";